import { render } from "./File.vue?vue&type=template&id=24cebcd4"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Apple/Desktop/projects/guguop/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__